/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed.index'
import { Route as AuthedVersionsRouteImport } from './routes/_authed.versions'
import { Route as AuthedAnalyticsRouteImport } from './routes/_authed.analytics'
import { Route as AuthedUsersIndexRouteImport } from './routes/_authed.users.index'
import { Route as AuthedTechniquesIndexRouteImport } from './routes/_authed.techniques.index'
import { Route as AuthedSuppressionsIndexRouteImport } from './routes/_authed.suppressions.index'
import { Route as AuthedSupportIndexRouteImport } from './routes/_authed.support.index'
import { Route as AuthedRecipesIndexRouteImport } from './routes/_authed.recipes.index'
import { Route as AuthedIngredientsIndexRouteImport } from './routes/_authed.ingredients.index'
import { Route as AuthedI18nIndexRouteImport } from './routes/_authed.i18n.index'
import { Route as AuthedHomesIndexRouteImport } from './routes/_authed.homes.index'
import { Route as AuthedAnalyticsIndexRouteImport } from './routes/_authed.analytics.index'
import { Route as AuthedUsersIdRouteImport } from './routes/_authed.users.$id'
import { Route as AuthedSupportIdRouteImport } from './routes/_authed.support.$id'
import { Route as AuthedRecipesNewRouteImport } from './routes/_authed.recipes.new'
import { Route as AuthedRecipesGenerateRouteImport } from './routes/_authed.recipes.generate'
import { Route as AuthedIngredientsNewRouteImport } from './routes/_authed.ingredients.new'
import { Route as AuthedI18nTagRouteImport } from './routes/_authed.i18n.$tag'
import { Route as AuthedHomesIdRouteImport } from './routes/_authed.homes.$id'
import { Route as AuthedEmailsDeliveryRouteImport } from './routes/_authed.emails.delivery'
import { Route as AuthedAnalyticsProductRouteImport } from './routes/_authed.analytics.product'
import { Route as AuthedAnalyticsPerformanceRouteImport } from './routes/_authed.analytics.performance'
import { Route as AuthedAnalyticsOverviewRouteImport } from './routes/_authed.analytics.overview'
import { Route as AuthedAnalyticsFunnelRouteImport } from './routes/_authed.analytics.funnel'
import { Route as AuthedAnalyticsBusinessRouteImport } from './routes/_authed.analytics.business'
import { Route as AuthedAiSettingsIndexRouteImport } from './routes/_authed.ai.settings.index'
import { Route as AuthedAiPromptsIndexRouteImport } from './routes/_authed.ai.prompts.index'
import { Route as AuthedAiLogsIndexRouteImport } from './routes/_authed.ai.logs.index'
import { Route as AuthedTechniquesIdEditRouteImport } from './routes/_authed.techniques.$id.edit'
import { Route as AuthedRecipesIdEditRouteImport } from './routes/_authed.recipes.$id.edit'
import { Route as AuthedIngredientsIdEditRouteImport } from './routes/_authed.ingredients.$id.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedVersionsRoute = AuthedVersionsRouteImport.update({
  id: '/versions',
  path: '/versions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsRoute = AuthedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersIndexRoute = AuthedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTechniquesIndexRoute = AuthedTechniquesIndexRouteImport.update({
  id: '/techniques/',
  path: '/techniques/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSuppressionsIndexRoute = AuthedSuppressionsIndexRouteImport.update({
  id: '/suppressions/',
  path: '/suppressions/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSupportIndexRoute = AuthedSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRecipesIndexRoute = AuthedRecipesIndexRouteImport.update({
  id: '/recipes/',
  path: '/recipes/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedIngredientsIndexRoute = AuthedIngredientsIndexRouteImport.update({
  id: '/ingredients/',
  path: '/ingredients/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedI18nIndexRoute = AuthedI18nIndexRouteImport.update({
  id: '/i18n/',
  path: '/i18n/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHomesIndexRoute = AuthedHomesIndexRouteImport.update({
  id: '/homes/',
  path: '/homes/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsIndexRoute = AuthedAnalyticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAnalyticsRoute,
} as any)
const AuthedUsersIdRoute = AuthedUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSupportIdRoute = AuthedSupportIdRouteImport.update({
  id: '/support/$id',
  path: '/support/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRecipesNewRoute = AuthedRecipesNewRouteImport.update({
  id: '/recipes/new',
  path: '/recipes/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRecipesGenerateRoute = AuthedRecipesGenerateRouteImport.update({
  id: '/recipes/generate',
  path: '/recipes/generate',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedIngredientsNewRoute = AuthedIngredientsNewRouteImport.update({
  id: '/ingredients/new',
  path: '/ingredients/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedI18nTagRoute = AuthedI18nTagRouteImport.update({
  id: '/i18n/$tag',
  path: '/i18n/$tag',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHomesIdRoute = AuthedHomesIdRouteImport.update({
  id: '/homes/$id',
  path: '/homes/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEmailsDeliveryRoute = AuthedEmailsDeliveryRouteImport.update({
  id: '/emails/delivery',
  path: '/emails/delivery',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsProductRoute = AuthedAnalyticsProductRouteImport.update({
  id: '/product',
  path: '/product',
  getParentRoute: () => AuthedAnalyticsRoute,
} as any)
const AuthedAnalyticsPerformanceRoute =
  AuthedAnalyticsPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthedAnalyticsRoute,
  } as any)
const AuthedAnalyticsOverviewRoute = AuthedAnalyticsOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AuthedAnalyticsRoute,
} as any)
const AuthedAnalyticsFunnelRoute = AuthedAnalyticsFunnelRouteImport.update({
  id: '/funnel',
  path: '/funnel',
  getParentRoute: () => AuthedAnalyticsRoute,
} as any)
const AuthedAnalyticsBusinessRoute = AuthedAnalyticsBusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => AuthedAnalyticsRoute,
} as any)
const AuthedAiSettingsIndexRoute = AuthedAiSettingsIndexRouteImport.update({
  id: '/ai/settings/',
  path: '/ai/settings/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAiPromptsIndexRoute = AuthedAiPromptsIndexRouteImport.update({
  id: '/ai/prompts/',
  path: '/ai/prompts/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAiLogsIndexRoute = AuthedAiLogsIndexRouteImport.update({
  id: '/ai/logs/',
  path: '/ai/logs/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTechniquesIdEditRoute = AuthedTechniquesIdEditRouteImport.update({
  id: '/techniques/$id/edit',
  path: '/techniques/$id/edit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRecipesIdEditRoute = AuthedRecipesIdEditRouteImport.update({
  id: '/recipes/$id/edit',
  path: '/recipes/$id/edit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedIngredientsIdEditRoute = AuthedIngredientsIdEditRouteImport.update({
  id: '/ingredients/$id/edit',
  path: '/ingredients/$id/edit',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/analytics': typeof AuthedAnalyticsRouteWithChildren
  '/versions': typeof AuthedVersionsRoute
  '/analytics/business': typeof AuthedAnalyticsBusinessRoute
  '/analytics/funnel': typeof AuthedAnalyticsFunnelRoute
  '/analytics/overview': typeof AuthedAnalyticsOverviewRoute
  '/analytics/performance': typeof AuthedAnalyticsPerformanceRoute
  '/analytics/product': typeof AuthedAnalyticsProductRoute
  '/emails/delivery': typeof AuthedEmailsDeliveryRoute
  '/homes/$id': typeof AuthedHomesIdRoute
  '/i18n/$tag': typeof AuthedI18nTagRoute
  '/ingredients/new': typeof AuthedIngredientsNewRoute
  '/recipes/generate': typeof AuthedRecipesGenerateRoute
  '/recipes/new': typeof AuthedRecipesNewRoute
  '/support/$id': typeof AuthedSupportIdRoute
  '/users/$id': typeof AuthedUsersIdRoute
  '/analytics/': typeof AuthedAnalyticsIndexRoute
  '/homes/': typeof AuthedHomesIndexRoute
  '/i18n/': typeof AuthedI18nIndexRoute
  '/ingredients/': typeof AuthedIngredientsIndexRoute
  '/recipes/': typeof AuthedRecipesIndexRoute
  '/support/': typeof AuthedSupportIndexRoute
  '/suppressions/': typeof AuthedSuppressionsIndexRoute
  '/techniques/': typeof AuthedTechniquesIndexRoute
  '/users/': typeof AuthedUsersIndexRoute
  '/ingredients/$id/edit': typeof AuthedIngredientsIdEditRoute
  '/recipes/$id/edit': typeof AuthedRecipesIdEditRoute
  '/techniques/$id/edit': typeof AuthedTechniquesIdEditRoute
  '/ai/logs/': typeof AuthedAiLogsIndexRoute
  '/ai/prompts/': typeof AuthedAiPromptsIndexRoute
  '/ai/settings/': typeof AuthedAiSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/versions': typeof AuthedVersionsRoute
  '/': typeof AuthedIndexRoute
  '/analytics/business': typeof AuthedAnalyticsBusinessRoute
  '/analytics/funnel': typeof AuthedAnalyticsFunnelRoute
  '/analytics/overview': typeof AuthedAnalyticsOverviewRoute
  '/analytics/performance': typeof AuthedAnalyticsPerformanceRoute
  '/analytics/product': typeof AuthedAnalyticsProductRoute
  '/emails/delivery': typeof AuthedEmailsDeliveryRoute
  '/homes/$id': typeof AuthedHomesIdRoute
  '/i18n/$tag': typeof AuthedI18nTagRoute
  '/ingredients/new': typeof AuthedIngredientsNewRoute
  '/recipes/generate': typeof AuthedRecipesGenerateRoute
  '/recipes/new': typeof AuthedRecipesNewRoute
  '/support/$id': typeof AuthedSupportIdRoute
  '/users/$id': typeof AuthedUsersIdRoute
  '/analytics': typeof AuthedAnalyticsIndexRoute
  '/homes': typeof AuthedHomesIndexRoute
  '/i18n': typeof AuthedI18nIndexRoute
  '/ingredients': typeof AuthedIngredientsIndexRoute
  '/recipes': typeof AuthedRecipesIndexRoute
  '/support': typeof AuthedSupportIndexRoute
  '/suppressions': typeof AuthedSuppressionsIndexRoute
  '/techniques': typeof AuthedTechniquesIndexRoute
  '/users': typeof AuthedUsersIndexRoute
  '/ingredients/$id/edit': typeof AuthedIngredientsIdEditRoute
  '/recipes/$id/edit': typeof AuthedRecipesIdEditRoute
  '/techniques/$id/edit': typeof AuthedTechniquesIdEditRoute
  '/ai/logs': typeof AuthedAiLogsIndexRoute
  '/ai/prompts': typeof AuthedAiPromptsIndexRoute
  '/ai/settings': typeof AuthedAiSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/analytics': typeof AuthedAnalyticsRouteWithChildren
  '/_authed/versions': typeof AuthedVersionsRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/analytics/business': typeof AuthedAnalyticsBusinessRoute
  '/_authed/analytics/funnel': typeof AuthedAnalyticsFunnelRoute
  '/_authed/analytics/overview': typeof AuthedAnalyticsOverviewRoute
  '/_authed/analytics/performance': typeof AuthedAnalyticsPerformanceRoute
  '/_authed/analytics/product': typeof AuthedAnalyticsProductRoute
  '/_authed/emails/delivery': typeof AuthedEmailsDeliveryRoute
  '/_authed/homes/$id': typeof AuthedHomesIdRoute
  '/_authed/i18n/$tag': typeof AuthedI18nTagRoute
  '/_authed/ingredients/new': typeof AuthedIngredientsNewRoute
  '/_authed/recipes/generate': typeof AuthedRecipesGenerateRoute
  '/_authed/recipes/new': typeof AuthedRecipesNewRoute
  '/_authed/support/$id': typeof AuthedSupportIdRoute
  '/_authed/users/$id': typeof AuthedUsersIdRoute
  '/_authed/analytics/': typeof AuthedAnalyticsIndexRoute
  '/_authed/homes/': typeof AuthedHomesIndexRoute
  '/_authed/i18n/': typeof AuthedI18nIndexRoute
  '/_authed/ingredients/': typeof AuthedIngredientsIndexRoute
  '/_authed/recipes/': typeof AuthedRecipesIndexRoute
  '/_authed/support/': typeof AuthedSupportIndexRoute
  '/_authed/suppressions/': typeof AuthedSuppressionsIndexRoute
  '/_authed/techniques/': typeof AuthedTechniquesIndexRoute
  '/_authed/users/': typeof AuthedUsersIndexRoute
  '/_authed/ingredients/$id/edit': typeof AuthedIngredientsIdEditRoute
  '/_authed/recipes/$id/edit': typeof AuthedRecipesIdEditRoute
  '/_authed/techniques/$id/edit': typeof AuthedTechniquesIdEditRoute
  '/_authed/ai/logs/': typeof AuthedAiLogsIndexRoute
  '/_authed/ai/prompts/': typeof AuthedAiPromptsIndexRoute
  '/_authed/ai/settings/': typeof AuthedAiSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/analytics'
    | '/versions'
    | '/analytics/business'
    | '/analytics/funnel'
    | '/analytics/overview'
    | '/analytics/performance'
    | '/analytics/product'
    | '/emails/delivery'
    | '/homes/$id'
    | '/i18n/$tag'
    | '/ingredients/new'
    | '/recipes/generate'
    | '/recipes/new'
    | '/support/$id'
    | '/users/$id'
    | '/analytics/'
    | '/homes/'
    | '/i18n/'
    | '/ingredients/'
    | '/recipes/'
    | '/support/'
    | '/suppressions/'
    | '/techniques/'
    | '/users/'
    | '/ingredients/$id/edit'
    | '/recipes/$id/edit'
    | '/techniques/$id/edit'
    | '/ai/logs/'
    | '/ai/prompts/'
    | '/ai/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/versions'
    | '/'
    | '/analytics/business'
    | '/analytics/funnel'
    | '/analytics/overview'
    | '/analytics/performance'
    | '/analytics/product'
    | '/emails/delivery'
    | '/homes/$id'
    | '/i18n/$tag'
    | '/ingredients/new'
    | '/recipes/generate'
    | '/recipes/new'
    | '/support/$id'
    | '/users/$id'
    | '/analytics'
    | '/homes'
    | '/i18n'
    | '/ingredients'
    | '/recipes'
    | '/support'
    | '/suppressions'
    | '/techniques'
    | '/users'
    | '/ingredients/$id/edit'
    | '/recipes/$id/edit'
    | '/techniques/$id/edit'
    | '/ai/logs'
    | '/ai/prompts'
    | '/ai/settings'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/analytics'
    | '/_authed/versions'
    | '/_authed/'
    | '/_authed/analytics/business'
    | '/_authed/analytics/funnel'
    | '/_authed/analytics/overview'
    | '/_authed/analytics/performance'
    | '/_authed/analytics/product'
    | '/_authed/emails/delivery'
    | '/_authed/homes/$id'
    | '/_authed/i18n/$tag'
    | '/_authed/ingredients/new'
    | '/_authed/recipes/generate'
    | '/_authed/recipes/new'
    | '/_authed/support/$id'
    | '/_authed/users/$id'
    | '/_authed/analytics/'
    | '/_authed/homes/'
    | '/_authed/i18n/'
    | '/_authed/ingredients/'
    | '/_authed/recipes/'
    | '/_authed/support/'
    | '/_authed/suppressions/'
    | '/_authed/techniques/'
    | '/_authed/users/'
    | '/_authed/ingredients/$id/edit'
    | '/_authed/recipes/$id/edit'
    | '/_authed/techniques/$id/edit'
    | '/_authed/ai/logs/'
    | '/_authed/ai/prompts/'
    | '/_authed/ai/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/versions': {
      id: '/_authed/versions'
      path: '/versions'
      fullPath: '/versions'
      preLoaderRoute: typeof AuthedVersionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics': {
      id: '/_authed/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthedAnalyticsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users/': {
      id: '/_authed/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthedUsersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/techniques/': {
      id: '/_authed/techniques/'
      path: '/techniques'
      fullPath: '/techniques/'
      preLoaderRoute: typeof AuthedTechniquesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/suppressions/': {
      id: '/_authed/suppressions/'
      path: '/suppressions'
      fullPath: '/suppressions/'
      preLoaderRoute: typeof AuthedSuppressionsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/support/': {
      id: '/_authed/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AuthedSupportIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recipes/': {
      id: '/_authed/recipes/'
      path: '/recipes'
      fullPath: '/recipes/'
      preLoaderRoute: typeof AuthedRecipesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ingredients/': {
      id: '/_authed/ingredients/'
      path: '/ingredients'
      fullPath: '/ingredients/'
      preLoaderRoute: typeof AuthedIngredientsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/i18n/': {
      id: '/_authed/i18n/'
      path: '/i18n'
      fullPath: '/i18n/'
      preLoaderRoute: typeof AuthedI18nIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/homes/': {
      id: '/_authed/homes/'
      path: '/homes'
      fullPath: '/homes/'
      preLoaderRoute: typeof AuthedHomesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics/': {
      id: '/_authed/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthedAnalyticsIndexRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
    '/_authed/users/$id': {
      id: '/_authed/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AuthedUsersIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/support/$id': {
      id: '/_authed/support/$id'
      path: '/support/$id'
      fullPath: '/support/$id'
      preLoaderRoute: typeof AuthedSupportIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recipes/new': {
      id: '/_authed/recipes/new'
      path: '/recipes/new'
      fullPath: '/recipes/new'
      preLoaderRoute: typeof AuthedRecipesNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recipes/generate': {
      id: '/_authed/recipes/generate'
      path: '/recipes/generate'
      fullPath: '/recipes/generate'
      preLoaderRoute: typeof AuthedRecipesGenerateRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ingredients/new': {
      id: '/_authed/ingredients/new'
      path: '/ingredients/new'
      fullPath: '/ingredients/new'
      preLoaderRoute: typeof AuthedIngredientsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/i18n/$tag': {
      id: '/_authed/i18n/$tag'
      path: '/i18n/$tag'
      fullPath: '/i18n/$tag'
      preLoaderRoute: typeof AuthedI18nTagRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/homes/$id': {
      id: '/_authed/homes/$id'
      path: '/homes/$id'
      fullPath: '/homes/$id'
      preLoaderRoute: typeof AuthedHomesIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/emails/delivery': {
      id: '/_authed/emails/delivery'
      path: '/emails/delivery'
      fullPath: '/emails/delivery'
      preLoaderRoute: typeof AuthedEmailsDeliveryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics/product': {
      id: '/_authed/analytics/product'
      path: '/product'
      fullPath: '/analytics/product'
      preLoaderRoute: typeof AuthedAnalyticsProductRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
    '/_authed/analytics/performance': {
      id: '/_authed/analytics/performance'
      path: '/performance'
      fullPath: '/analytics/performance'
      preLoaderRoute: typeof AuthedAnalyticsPerformanceRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
    '/_authed/analytics/overview': {
      id: '/_authed/analytics/overview'
      path: '/overview'
      fullPath: '/analytics/overview'
      preLoaderRoute: typeof AuthedAnalyticsOverviewRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
    '/_authed/analytics/funnel': {
      id: '/_authed/analytics/funnel'
      path: '/funnel'
      fullPath: '/analytics/funnel'
      preLoaderRoute: typeof AuthedAnalyticsFunnelRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
    '/_authed/analytics/business': {
      id: '/_authed/analytics/business'
      path: '/business'
      fullPath: '/analytics/business'
      preLoaderRoute: typeof AuthedAnalyticsBusinessRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
    '/_authed/ai/settings/': {
      id: '/_authed/ai/settings/'
      path: '/ai/settings'
      fullPath: '/ai/settings/'
      preLoaderRoute: typeof AuthedAiSettingsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ai/prompts/': {
      id: '/_authed/ai/prompts/'
      path: '/ai/prompts'
      fullPath: '/ai/prompts/'
      preLoaderRoute: typeof AuthedAiPromptsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ai/logs/': {
      id: '/_authed/ai/logs/'
      path: '/ai/logs'
      fullPath: '/ai/logs/'
      preLoaderRoute: typeof AuthedAiLogsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/techniques/$id/edit': {
      id: '/_authed/techniques/$id/edit'
      path: '/techniques/$id/edit'
      fullPath: '/techniques/$id/edit'
      preLoaderRoute: typeof AuthedTechniquesIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/recipes/$id/edit': {
      id: '/_authed/recipes/$id/edit'
      path: '/recipes/$id/edit'
      fullPath: '/recipes/$id/edit'
      preLoaderRoute: typeof AuthedRecipesIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ingredients/$id/edit': {
      id: '/_authed/ingredients/$id/edit'
      path: '/ingredients/$id/edit'
      fullPath: '/ingredients/$id/edit'
      preLoaderRoute: typeof AuthedIngredientsIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedAnalyticsRouteChildren {
  AuthedAnalyticsBusinessRoute: typeof AuthedAnalyticsBusinessRoute
  AuthedAnalyticsFunnelRoute: typeof AuthedAnalyticsFunnelRoute
  AuthedAnalyticsOverviewRoute: typeof AuthedAnalyticsOverviewRoute
  AuthedAnalyticsPerformanceRoute: typeof AuthedAnalyticsPerformanceRoute
  AuthedAnalyticsProductRoute: typeof AuthedAnalyticsProductRoute
  AuthedAnalyticsIndexRoute: typeof AuthedAnalyticsIndexRoute
}

const AuthedAnalyticsRouteChildren: AuthedAnalyticsRouteChildren = {
  AuthedAnalyticsBusinessRoute: AuthedAnalyticsBusinessRoute,
  AuthedAnalyticsFunnelRoute: AuthedAnalyticsFunnelRoute,
  AuthedAnalyticsOverviewRoute: AuthedAnalyticsOverviewRoute,
  AuthedAnalyticsPerformanceRoute: AuthedAnalyticsPerformanceRoute,
  AuthedAnalyticsProductRoute: AuthedAnalyticsProductRoute,
  AuthedAnalyticsIndexRoute: AuthedAnalyticsIndexRoute,
}

const AuthedAnalyticsRouteWithChildren = AuthedAnalyticsRoute._addFileChildren(
  AuthedAnalyticsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAnalyticsRoute: typeof AuthedAnalyticsRouteWithChildren
  AuthedVersionsRoute: typeof AuthedVersionsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedEmailsDeliveryRoute: typeof AuthedEmailsDeliveryRoute
  AuthedHomesIdRoute: typeof AuthedHomesIdRoute
  AuthedI18nTagRoute: typeof AuthedI18nTagRoute
  AuthedIngredientsNewRoute: typeof AuthedIngredientsNewRoute
  AuthedRecipesGenerateRoute: typeof AuthedRecipesGenerateRoute
  AuthedRecipesNewRoute: typeof AuthedRecipesNewRoute
  AuthedSupportIdRoute: typeof AuthedSupportIdRoute
  AuthedUsersIdRoute: typeof AuthedUsersIdRoute
  AuthedHomesIndexRoute: typeof AuthedHomesIndexRoute
  AuthedI18nIndexRoute: typeof AuthedI18nIndexRoute
  AuthedIngredientsIndexRoute: typeof AuthedIngredientsIndexRoute
  AuthedRecipesIndexRoute: typeof AuthedRecipesIndexRoute
  AuthedSupportIndexRoute: typeof AuthedSupportIndexRoute
  AuthedSuppressionsIndexRoute: typeof AuthedSuppressionsIndexRoute
  AuthedTechniquesIndexRoute: typeof AuthedTechniquesIndexRoute
  AuthedUsersIndexRoute: typeof AuthedUsersIndexRoute
  AuthedIngredientsIdEditRoute: typeof AuthedIngredientsIdEditRoute
  AuthedRecipesIdEditRoute: typeof AuthedRecipesIdEditRoute
  AuthedTechniquesIdEditRoute: typeof AuthedTechniquesIdEditRoute
  AuthedAiLogsIndexRoute: typeof AuthedAiLogsIndexRoute
  AuthedAiPromptsIndexRoute: typeof AuthedAiPromptsIndexRoute
  AuthedAiSettingsIndexRoute: typeof AuthedAiSettingsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAnalyticsRoute: AuthedAnalyticsRouteWithChildren,
  AuthedVersionsRoute: AuthedVersionsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedEmailsDeliveryRoute: AuthedEmailsDeliveryRoute,
  AuthedHomesIdRoute: AuthedHomesIdRoute,
  AuthedI18nTagRoute: AuthedI18nTagRoute,
  AuthedIngredientsNewRoute: AuthedIngredientsNewRoute,
  AuthedRecipesGenerateRoute: AuthedRecipesGenerateRoute,
  AuthedRecipesNewRoute: AuthedRecipesNewRoute,
  AuthedSupportIdRoute: AuthedSupportIdRoute,
  AuthedUsersIdRoute: AuthedUsersIdRoute,
  AuthedHomesIndexRoute: AuthedHomesIndexRoute,
  AuthedI18nIndexRoute: AuthedI18nIndexRoute,
  AuthedIngredientsIndexRoute: AuthedIngredientsIndexRoute,
  AuthedRecipesIndexRoute: AuthedRecipesIndexRoute,
  AuthedSupportIndexRoute: AuthedSupportIndexRoute,
  AuthedSuppressionsIndexRoute: AuthedSuppressionsIndexRoute,
  AuthedTechniquesIndexRoute: AuthedTechniquesIndexRoute,
  AuthedUsersIndexRoute: AuthedUsersIndexRoute,
  AuthedIngredientsIdEditRoute: AuthedIngredientsIdEditRoute,
  AuthedRecipesIdEditRoute: AuthedRecipesIdEditRoute,
  AuthedTechniquesIdEditRoute: AuthedTechniquesIdEditRoute,
  AuthedAiLogsIndexRoute: AuthedAiLogsIndexRoute,
  AuthedAiPromptsIndexRoute: AuthedAiPromptsIndexRoute,
  AuthedAiSettingsIndexRoute: AuthedAiSettingsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
